export class SpecialPropertySplitter {

    public parameters: Array<any>;
    public splitValues: Function;

    /**
     * Builds a new group special property object.
     *
     * @param        p_splitFunction        Function    Reference to the function used to split a value
     */
    constructor(p_splitFunction: Function, p_parameters: Array<any>) {
        this.splitValues = p_splitFunction;
        this.parameters = p_parameters;
    }

    /**
     * Converts the instance to a string that can be used when trace()ing the object
     */
    public toString(): string {
        let value: string = '';
        value += '[SpecialPropertySplitter ';
        value += 'splitValues:' + this.splitValues; // .tostring();
        value += ', ';
        value += 'parameters:' + this.parameters;
        value += ']';
        return value;
    }
}